/*
    NOTICE - this page needs to be revised to work with the new data flow as of 3/7/20: we just
    started using apollo-cache-persist and stopped manging localStorage data manually, with the
    exception of the token.

    Switching to a dummy export so we don't use this in its broken form by accident.
*/
import React from 'react';

export const VerifyAccountWithCode = (): JSX.Element => <div>Fix Me</div>;

/*
import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import _get from 'lodash/get';

import {
    Button,
    DotLogo,
    Input,
    SubHeader,
    IconLeftArrow,
} from '@trqk/components';
import { queryStrings } from '@trqk/resolvers';
import { getWebpackEnvVar } from '@trqk/utils';

import { AccountManagement, AccountManagementWrapper } from '../templates';
import { PATHS } from '../../constants';


const {
    CONFIRM_REGISTRATION_WITH_COGNITO,
    SIGN_IN_WITH_COGNITO,
} = queryStrings;
const defaultErrorMessage = 'Invalid code; please try again.';


export const VerifyAccountWithCode_fix_me = () => {
    const clientId = getWebpackEnvVar('web', 'AWS_APP_CLIENT_ID');
    const userPoolId = getWebpackEnvVar('web', 'AWS_USER_POOL_ID');
    const history = useHistory();
    const [verificationCode, setVerificationCode] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [deliveryMedium, setDeliveryMedium] = useState('');
    const [
        confirmRegistrationErrorMessage,
        setConfirmRegistrationErrorMessage,
    ] = useState('');

    const [signInWithCognito] = useMutation(SIGN_IN_WITH_COGNITO, {
        onCompleted: data => {
            const error = _get(data, ['signInWithCognito', 'error']);

            if (error) {
                history.push(PATHS.LANDING);
            } else {
                const token = _get(data, [
                    'signInWithCognito',
                    'token',
                ]);

                localStorage.setItem('token', token);
                history.push('/landing');
            }
        },
    });

    const [confirmRegistrationWithCognito] = useMutation(
        CONFIRM_REGISTRATION_WITH_COGNITO,
        {
            onCompleted: data => {
                const error = _get(data, [
                    'confirmRegistrationWithCognito',
                    'error',
                ]);

                if (error) {
                    setConfirmRegistrationErrorMessage(defaultErrorMessage);
                } else {
                    signInWithCognito({
                        variables: {
                            username,
                            password,
                            clientId,
                            userPoolId,
                            updateUiState: true,
                        },
                    });
                }
            },
        },
    );

    // When the GET_SESSION query data is available, get the username from it and use it to update
    // the local `username` state
    if (isSigningUp) {
        const prevUsername = _get(sessionData, 'username');
        const prevPassword = _get(sessionData, 'password');
        const prevDeliveryMedium = _get(sessionData, [
            'codeDeliveryDetails',
            'deliveryMedium',
        ]);

        if (username !== prevUsername) {
            setUsername(prevUsername);
        }

        if (password !== prevPassword) {
            setPassword(prevPassword);
        }

        if (deliveryMedium !== prevDeliveryMedium) {
            setDeliveryMedium(prevDeliveryMedium);
        }
    }

    const disableFormSubmission = !username || !verificationCode || !password;
    const verificationMessage = deliveryMedium
        ? `Please enter the code sent via ${deliveryMedium}.`
        : 'Please enter your verification code.';

    return (
        <AccountManagementWrapper>
            <AccountManagement>
                <div className="r1c1 pl-12 pt-10 rounded-tl">
                    <Link to={PATHS.SIGN_IN} tabIndex={3}>
                        <IconLeftArrow width={32} />
                        Back
                    </Link>
                </div>
                <div className="r1c2"></div>
                <div className="r1c3 rounted-tr"></div>
                <div className="lower-left ml-6 mr-6 self-center">
                    <div className="flex justify-center items-stretch">
                        <div className="flex-initial">
                            <DotLogo />
                        </div>
                    </div>
                </div>
                <div className="r2c2 bg-secondary-500 rounded-sm"></div>
                <div className="r2c3 rounded-tr pr-12 pl-12">
                    <h2>Verify Account</h2>
                    {!confirmRegistrationErrorMessage && (
                        <SubHeader>{verificationMessage}</SubHeader>
                    )}
                    {confirmRegistrationErrorMessage && (
                        <div>{confirmRegistrationErrorMessage}</div>
                    )}
                    <Input
                        addClasses="my-3"
                        inputId="verificationCode"
                        handleChange={setVerificationCode}
                        value={verificationCode}
                        placeholder="Verification code"
                        tabIndex={1}
                    />
                </div>
                <div className="r3c2"></div>
                <div className="r3c3 pr-12"></div>
                <div className="r4c2"></div>
                <div className="r4c3 ml-12 mr-12 mt-5">
                    <Button
                        disabled={disableFormSubmission}
                        handleClick={() => {
                            confirmRegistrationWithCognito({
                                variables: {
                                    username,
                                    verificationCode,
                                    clientId,
                                    userPoolId,
                                },
                            });
                        }}
                        color="secondary"
                        tabIndex={2}
                    >
                        Submit
                    </Button>
                </div>
            </AccountManagement>
        </AccountManagementWrapper>
    );
};

*/
